import React from "react";
import styled, { useTheme, keyframes } from "styled-components";


const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const RotationWrapper = styled.div`
  display: inline-block;
  animation: ${rotate} 2.5s linear infinite;
`;



export const LoadingDotsSvg = (props) => {
  const { width, height } = props;
  const theme = useTheme();

  return (
    <RotationWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "16"}
        height={height ?? "15"}
        fill="none"
        viewBox={`0 0 ${width ?? 16} ${height ?? 15}`}
      >
        <circle
          cx="13.828"
          cy="7.27"
          r="1.167"
          fill="#1AAA60"
          opacity="0.4"
          transform="rotate(177.742 13.828 7.27)"
        ></circle>
        <circle
          cx="2.171"
          cy="7.73"
          r="1.167"
          fill="#1AAA60"
          opacity="0.8"
          transform="rotate(177.742 2.17 7.73)"
        ></circle>
        <circle
          cx="8.23"
          cy="13.329"
          r="1.167"
          fill="#1AAA60"
          opacity="0.6"
          transform="rotate(177.742 8.23 13.329)"
        ></circle>
        <circle
          cx="7.77"
          cy="1.671"
          r="1.167"
          fill="#1AAA60"
          transform="rotate(177.742 7.77 1.671)"
        ></circle>
        <circle
          cx="4.041"
          cy="11.784"
          r="1.167"
          fill="#1AAA60"
          opacity="0.7"
          transform="rotate(-137.258 4.041 11.784)"
        ></circle>
        <circle
          cx="11.959"
          cy="3.216"
          r="1.167"
          fill="#1AAA60"
          opacity="0.3"
          transform="rotate(-137.258 11.959 3.216)"
        ></circle>
        <circle
          cx="3.716"
          cy="3.541"
          r="1.167"
          fill="#1AAA60"
          opacity="0.9"
          transform="rotate(-47.258 3.716 3.541)"
        ></circle>
        <circle
          cx="12.284"
          cy="11.459"
          r="1.167"
          fill="#1AAA60"
          opacity="0.5"
          transform="rotate(-47.258 12.284 11.459)"
        ></circle>
      </svg>
    </RotationWrapper>
  );
};
